import * as e from "react";
import r from "../lib/IconBase.es.js";
import t from "../defs/FileImage.es.js";
const o = e.forwardRef((a, m) => /* @__PURE__ */ e.createElement(r, { ref: m, ...a, weights: t }));
o.displayName = "FileImageIcon";
const s = o;
export {
  s as FileImage,
  o as FileImageIcon
};
